import { BrowserRouter, Router, Route, Routes, Navigate } from 'react-router-dom';

import './App.css';
import Home from './components/Home';
import Detection from './components/Detection';
import Result from './components/Result';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter basename="/detection">
      <ToastContainer autoClose={8000} />
      <Routes basename={"/bash"}>

        <Route path="/" element={<Home />} />
        <Route path="/detection" element={<Detection />} />
        <Route path="/result/:id" element={<Result />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
